const ResponseForm = require("app/components/forms/ResponseForm");
const csrfToken = require("app/services/csrfToken");
const router = require("app/services/router");
const assign = require("object-assign");
const PropTypes = require("prop-types");
const Trans = require('app/components/trans/Trans')


class BaseForm extends ResponseForm {

	get baseClassName() {
		return super.baseClassName + " auth-form";
	}

	renderStatusError() {
		return this.renderError("status", "status-error");
	}

}

/////////////////////////////////
// Login
/////////////////////////////////

class Login extends BaseForm {

	get baseClassName() {
		return super.baseClassName + " auth-login";
	}

	get actionUrl() {
		return router.route("auth.login.do");
	}

	onComplete(response) {
		window.location = response.redirect || router.route("home");
	}

	renderForm() {
		return (
			<form onSubmit={this.onSubmit}>
				<input type="hidden" name="_token" value={csrfToken()}/>
				<div className="inputs">
					<div className="field required">
                      <label htmlFor="input_email"> <Trans>E-mail eller brugernavn</Trans></label>
						<input type="text" id="input_email" name="email" required={true}/>
						{this.renderError("email")}
					</div>
					<div className="field required">
						<label htmlFor="input_password"><Trans>Adgangskode</Trans></label>
						<input type="password" id="input_password" name="password" required={true}/>
						{this.renderError("password")}
					</div>
				</div>
				{this.renderStatusError()}
				<div className="button leftalign">
					<div className="submit-container">
						<input type="submit" value={translate("Log ind")}/>
					</div>
					<a href={router.route("auth.forgot-password")}><Trans>Glemt adgangskode?</Trans></a>
				</div>
			</form>
		);
	}

}

class ForgotPassword extends BaseForm {

	get baseClassName() {
		return super.baseClassName + " auth-forgot-password";
	}

	get actionUrl() {
		return router.route("auth.forgot-password.do");
	}

	renderMessageAction() {
      return (<a href={router.route("auth.login")}><Trans>Tilbage til login side</Trans></a>);
	}

	renderForm() {
		return (
			<form onSubmit={this.onSubmit}>
				<input type="hidden" name="_token" value={csrfToken()}/>
				<div className="inputs">
					<div className="field required">
                      <label htmlFor="input_email"><Trans>E-mail eller brugernavn</Trans></label>
						<input type="text" id="input_email" name="email" required={true}/>
						{this.renderError("email")}
					</div>
				</div>
				{this.renderStatusError()}
				<div className="button leftalign">
					<div className="submit-container">
						<input type="submit" value={ translate("Send")}/>
					</div>
                  <a href={router.route("auth.login")}><Trans>Tilbage til login side</Trans></a>
				</div>
			</form>
		);
	}

}

class ResetPassword extends BaseForm {

	static get propTypes() {
		return assign(super.propTypes || {}, {
			token: PropTypes.string.isRequired
		});
	}

	get baseClassName() {
		return super.baseClassName + " auth-reset-password";
	}

	get actionUrl() {
		return router.route("auth.reset-password.do");
	}

	renderMessageAction() {
      return (<a href={router.route("auth.login")}><Trans>Tilbage til login side</Trans></a>);
	}

	renderForm() {
		return (
			<form onSubmit={this.onSubmit}>
				<input type="hidden" name="_token" value={csrfToken()}/>
				<input type="hidden" name="token" value={this.props.token}/>
				<div className="inputs">
					<div className="field required">
                      <label htmlFor="input_email"><Trans>Email</Trans></label>
						<input type="email" id="input_email" name="email" required={true}/>
						{this.renderError("email")}
					</div>
					<div className="field required">
                      <label htmlFor="input_password"><Trans>Ny adgangskode</Trans></label>
						<input type="password" id="input_password" name="password" required={true}/>
						{this.renderError("password")}
					</div>
					<div className="field required">
						<label htmlFor="input_password_confirmation"><Trans>Bekærft ny adgangskode</Trans></label>
						<input type="password" id="input_password_confirmation" name="password_confirmation" required={true}/>
						{this.renderError("password_confirmation")}
					</div>
				</div>
				{this.renderStatusError()}
				<div className="button leftalign">
					<div className="submit-container">
						<input type="submit" value={ translate("Nulstil")}/>
					</div>
                  <a href={router.route("auth.login")}><Trans>Tilbage til login side</Trans></a>
				</div>
			</form>
		);
	}

}

module.exports = {
	Login,
	ForgotPassword,
	ResetPassword
};
